export default {
  loginBackground: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#f8f8f8',
  },
  loginBox: {
    margin: 'auto',
    padding: '36px',
    boxShadow: '0 0 100px rgba(0, 0, 0, 0.15)',
    width: '320px',
    borderRadius: '5px',
  },
  signInButton: {
    width: '100%',
  },
  companyName: {
    marginBottom: '45px',
    fontSize: '18px',
    display: 'block',
    textAlign: 'center',
    fontWeight: '600',
    color: '@primary-color',
  },
  linkStyle: {
    marginTop: '35px',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};
